import { useEffect, useState } from 'react'
import { CommonUtility, ErrorConstant, TemplateService } from 'utility'

export const GetMasterResponses = isAuthenticated => {
    const [data, setData] = useState('')
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await TemplateService.getMasterResponse()
                const temp = { ...result }
                temp.GroupedResponse = CommonUtility.groupByData(
                    temp.UserMultipleResponse || temp.MultipleResponse,
                    'GroupId',
                ).map(item => ({
                    GroupId: item.title,
                    Items: item.data,
                }))
                setData(temp)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        if (isAuthenticated) {
            fetchData()
        }
    }, [isAuthenticated])

    return { data, error, loading, setData }
}

export const GetMultipleResponseTypes = () => {
    const [data, setData] = useState('')
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await TemplateService.getMultiResponceTypes()
                setData(result)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    return { data, error, loading, setData }
}
